"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var classnames = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var ArrowLeftIcon_1 = require("../../Icons/ArrowLeftIcon");
var ArrowRightIcon_1 = require("../../Icons/ArrowRightIcon");
var date_utils_1 = require("./date_utils");
var month_1 = require("./month");
var month_dropdown_1 = require("./month_dropdown");
var year_dropdown_1 = require("./year_dropdown");
var date_fns_1 = require("date-fns");
var dateFormat_1 = require("../../../utils/dateFormat");
var Calendar = /** @class */ (function (_super) {
    __extends(Calendar, _super);
    function Calendar(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClickOutside = function (event) {
            _this.props.onClickOutside(event);
        };
        _this.handleIncreaseMonth = function () {
            _this.setState(function (state) {
                return { date: date_fns_1.addMonths(state.date, 1) };
            }, function () { return _this.handleMonthChange(_this.state.date); });
            _this.nextMonthButton.blur();
        };
        _this.handleDecreaseMonth = function () {
            _this.setState(function (state) {
                return { date: date_fns_1.subMonths(state.date, 1) };
            }, function () { return _this.handleMonthChange(_this.state.date); });
            _this.previousMonthButton.blur();
        };
        _this.handleDayClick = function (day, event) {
            _this.props.onSelect(day, event);
        };
        _this.handleDayMouseEnter = function (day) {
            _this.setState({ selectingDate: day });
        };
        _this.handleMonthMouseLeave = function () {
            _this.setState({ selectingDate: null });
        };
        _this.handleMonthChange = function (date) {
            if (_this.props.onMonthChange) {
                _this.props.onMonthChange(date);
            }
        };
        _this.handleChangeYear = function (year) {
            _this.setState(function (state) {
                return {
                    date: date_fns_1.setYear(state.date, year)
                };
            });
        };
        _this.handleChangeMonth = function (month) {
            _this.setState(function (state) {
                return {
                    date: date_fns_1.setMonth(state.date, month)
                };
            }, function () { return _this.handleMonthChange(_this.state.date); });
        };
        _this.state = {
            date: _this.getDateInView(),
            selectingDate: null
        };
        return _this;
    }
    Calendar.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.preSelection && !date_fns_1.isSameDay(this.props.preSelection, prevProps.preSelection)) {
            this.setState({
                date: this.props.preSelection
            });
        }
        else if (this.props.openToDate && !date_fns_1.isSameDay(this.props.openToDate, prevProps.openToDate)) {
            this.setState({
                date: this.props.openToDate
            });
        }
    };
    Calendar.prototype.getDateInView = function () {
        var _a = this.props, preSelection = _a.preSelection, selected = _a.selected, openToDate = _a.openToDate;
        var minDate = date_utils_1.getEffectiveMinDate(this.props);
        var maxDate = date_utils_1.getEffectiveMaxDate(this.props);
        var current = new Date();
        var initialDate = preSelection || selected;
        if (initialDate) {
            return initialDate;
        }
        else if (minDate && maxDate && openToDate && date_fns_1.isWithinInterval(openToDate, { start: minDate, end: maxDate })) {
            return openToDate;
        }
        else if (minDate && openToDate && date_fns_1.isAfter(openToDate, minDate)) {
            return openToDate;
        }
        else if (minDate && date_fns_1.isAfter(minDate, current)) {
            return minDate;
        }
        else if (maxDate && openToDate && date_fns_1.isBefore(openToDate, maxDate)) {
            return openToDate;
        }
        else if (maxDate && date_fns_1.isBefore(maxDate, current)) {
            return maxDate;
        }
        else if (openToDate) {
            return openToDate;
        }
        else {
            return current;
        }
    };
    Calendar.prototype.header = function () {
        var _this = this;
        var dayNames = [];
        if (this.props.showWeekNumbers) {
            dayNames.push(React.createElement("div", { key: "W", className: "ee_react-datepicker__day-name" }, "#"));
        }
        return dayNames.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
            return (React.createElement("div", { key: offset, role: "columnheader", "aria-label": dateFormat_1.weekdayLabels[_this.props.locale].long[offset], className: "ee_react-datepicker__day-name" }, dateFormat_1.weekdayLabels[_this.props.locale].short[offset]));
        }));
    };
    Calendar.prototype.renderPreviousMonthButton = function () {
        var _this = this;
        if (!this.props.forceShowMonthNavigation && date_utils_1.allDaysDisabledBeforeMonth(this.state.date, this.props)) {
            return;
        }
        return (React.createElement("button", { className: "ee_react-datepicker__navigation__month", onClick: this.handleDecreaseMonth, ref: function (button) { return (_this.previousMonthButton = button); }, disabled: date_utils_1.allDaysDisabledBeforeMonth(this.state.date, this.props), "aria-label": "Vorheriger Monat" },
            React.createElement(ArrowLeftIcon_1.default, { title: "Vorheriger Monat", width: 20, height: 20 })));
    };
    Calendar.prototype.renderNextMonthButton = function () {
        var _this = this;
        if (!this.props.forceShowMonthNavigation && date_utils_1.allDaysDisabledAfterMonth(this.state.date, this.props)) {
            return;
        }
        return (React.createElement("button", { className: "ee_react-datepicker__navigation__month", onClick: this.handleIncreaseMonth, ref: function (button) { return (_this.nextMonthButton = button); }, disabled: date_utils_1.allDaysDisabledAfterMonth(this.state.date, this.props), "aria-label": "N\u00E4chster Monat" },
            React.createElement(ArrowRightIcon_1.default, { title: "N\u00E4chster Monat", width: 20, height: 20 })));
    };
    Calendar.prototype.renderCurrentMonth = function (date) {
        if (date === void 0) { date = this.state.date; }
        var classes = classnames('ee_react-datepicker__current-month', {
            'ee_react-datepicker__current-month--hasYearDropdown': this.props.showYearDropdown,
            'ee_react-datepicker__current-month--hasMonthDropdown': this.props.showMonthDropdown
        });
        return React.createElement("div", { className: classes }, dateFormat_1.format(date, this.props.dateFormat));
    };
    Calendar.prototype.renderYearDropdown = function (overrideHide) {
        if (overrideHide === void 0) { overrideHide = false; }
        if (!this.props.showYearDropdown || overrideHide) {
            return;
        }
        return (React.createElement(year_dropdown_1.default, { dropdownMode: this.props.dropdownMode, onChange: this.handleChangeYear, minDate: this.props.minDate, maxDate: this.props.maxDate, year: date_fns_1.getYear(this.state.date), scrollableYearDropdown: this.props.scrollableYearDropdown, includeDates: this.props.includeDates }));
    };
    Calendar.prototype.renderMonthDropdown = function () {
        if (!this.props.showMonthDropdown) {
            return;
        }
        return (React.createElement(month_dropdown_1.default, { dropdownMode: this.props.dropdownMode, locale: this.props.locale, onChange: this.handleChangeMonth, month: date_fns_1.getMonth(this.state.date) }));
    };
    Calendar.prototype.renderTodayButton = function () {
        var _this = this;
        if (!this.props.todayButton) {
            return;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "ee_react-datepicker__today-button", onClick: function (event) { return _this.props.onSelect(date_fns_1.startOfDay(new Date()), event); } }, this.props.todayButton)));
    };
    Calendar.prototype.renderMonths = function () {
        var classes = classnames('ee_react-datepicker__header__dropdown', "ee_react-datepicker__header__dropdown--" + this.props.dropdownMode);
        var monthList = [];
        // TODO: monthsShown ist immer 1, dadurch kann man diesen Code hier
        // vereinfachen und renderMonthDropdown und die MonthDropdown-Komponente
        // komplett löschen
        for (var i = 0; i < this.props.monthsShown; ++i) {
            var monthDate = date_fns_1.addMonths(this.state.date, i);
            var monthKey = "month-" + i;
            monthList.push(React.createElement("div", { key: monthKey, className: "ee_react-datepicker__month-container" },
                React.createElement("div", { className: "ee_react-datepicker__header" },
                    this.renderPreviousMonthButton(),
                    this.renderCurrentMonth(monthDate),
                    this.renderNextMonthButton(),
                    React.createElement("div", { className: classes },
                        this.renderMonthDropdown(),
                        this.renderYearDropdown(i !== 0))),
                React.createElement("div", { className: "ee_react-datepicker__calendar" },
                    React.createElement("div", { className: "ee_react-datepicker__day-names" }, this.header()),
                    React.createElement(month_1.default, { day: monthDate, onDayClick: this.handleDayClick, onDayMouseEnter: this.handleDayMouseEnter, onMouseLeave: this.handleMonthMouseLeave, highlightDates: this.props.highlightDates, minDate: this.props.minDate, maxDate: this.props.maxDate, includeDates: this.props.includeDates, excludeDates: this.props.excludeDates, filterDate: this.props.filterDate, selectingDate: this.state.selectingDate, inline: this.props.inline, fixedHeight: this.props.fixedHeight, preSelection: this.props.preSelection, selected: this.props.selected, selectsStart: this.props.selectsStart, selectsEnd: this.props.selectsEnd, showWeekNumbers: this.props.showWeekNumbers, startDate: this.props.startDate, endDate: this.props.endDate, peekNextMonth: this.props.peekNextMonth }))));
        }
        return monthList;
    };
    Calendar.prototype.render = function () {
        return (React.createElement("div", { className: classnames('ee_react-datepicker', this.props.className) },
            React.createElement("div", { className: 'ee_react-datepicker__triangle' }),
            this.renderMonths(),
            this.renderTodayButton(),
            this.props.children));
    };
    Calendar.displayName = 'Calendar';
    Calendar.propTypes = {
        className: PropTypes.string,
        children: PropTypes.node,
        dateFormat: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.array.isRequired]).isRequired,
        dropdownMode: PropTypes.oneOf(['scroll', 'select']).isRequired,
        endDate: PropTypes.object,
        excludeDates: PropTypes.array,
        filterDate: PropTypes.func,
        fixedHeight: PropTypes.bool,
        highlightDates: PropTypes.array,
        includeDates: PropTypes.array,
        inline: PropTypes.bool,
        locale: PropTypes.string,
        maxDate: PropTypes.object,
        minDate: PropTypes.object,
        monthsShown: PropTypes.number,
        onClickOutside: PropTypes.func.isRequired,
        onMonthChange: PropTypes.func,
        forceShowMonthNavigation: PropTypes.bool,
        onDropdownFocus: PropTypes.func,
        onSelect: PropTypes.func.isRequired,
        openToDate: PropTypes.object,
        peekNextMonth: PropTypes.bool,
        scrollableYearDropdown: PropTypes.bool,
        preSelection: PropTypes.object,
        selected: PropTypes.object,
        selectsEnd: PropTypes.bool,
        selectsStart: PropTypes.bool,
        showMonthDropdown: PropTypes.bool,
        showWeekNumbers: PropTypes.bool,
        showYearDropdown: PropTypes.bool,
        startDate: PropTypes.object,
        todayButton: PropTypes.string
    };
    Calendar.defaultProps = {
        dateFormat: 'MMMM yyyy',
        dropdownMode: 'scroll',
        locale: 'de-de',
        onClickOutside: function () {
            /* empty on purpose */
        },
        onDropdownFocus: function () {
            /* empty on purpose */
        },
        onSelect: function () {
            /* empty on purpose */
        },
        monthsShown: 1,
        forceShowMonthNavigation: false,
        disableOnClickOutside: function () {
            /* empty on purpose */
        },
        enableOnClickOutside: function () {
            /* empty on purpose */
        }
    };
    return Calendar;
}(React.Component));
exports.Calendar = Calendar;
exports.default = Calendar;
//# sourceMappingURL=calendar.js.map